module.exports = __webpack_public_path__ + "img/header-weddingRingsCeramic@2x.8da0f1a.webp";